import { type PropsWithChildren, useCallback } from "react";
import { useDispatch } from "react-redux";
import type { ChatPropertiesType } from "@b2bportal/chat-api";
import { toggleChatWindow } from "@b2bportal/core-self-serve";
import type { ChatTransfer } from "@b2bportal/ivr-api";
import {
  ChatSupportContext,
  type IChatSupportContext,
} from "@hopper-b2b/self-serve";

/**
 * RBC-owned support provider for the HTS Assist chat widget. It dispatches
 * the shared supportChat.toggleChatWindow action that the widget observes.
 */
export const HtsAssistChatSupportProvider = ({
  children,
}: PropsWithChildren) => {
  const dispatch = useDispatch();

  const openChatWindow = useCallback(() => {
    // TODO - also check kill-switch to see if AI Service is down. If so, fallback to Kustomer
    dispatch(toggleChatWindow());
  }, [dispatch]);

  const openGeneralSupportChat = useCallback(async () => {
    // TODO - also check kill-switch to see if AI Service is down. If so, fallback to Kustomer
    dispatch(toggleChatWindow());
  }, [dispatch]);

  const openProductSpecificSupportChat = useCallback(
    async (
      _productId: string,
      _productType: ChatPropertiesType,
      _requestType: string,
      _chatTransfer?: ChatTransfer // Unused currently
    ) => {
      // TODO - also check kill-switch to see if AI Service is down. If so, fallback to Kustomer
      dispatch(toggleChatWindow());
    },
    [dispatch]
  );

  const supportContext: IChatSupportContext = {
    openChatWindow,
    generalSupportChat: openGeneralSupportChat,
    productSupportChat: openProductSpecificSupportChat,
  };

  return (
    <ChatSupportContext.Provider value={supportContext}>
      {children}
    </ChatSupportContext.Provider>
  );
};
